/**
 * TextFieldType — krótki tekst (varchar). Storage: PG TEXT.
 */

import type { FieldInputProps, FieldTypeDefinition } from '../FieldRegistry';

function TextInput({ field, value, onChange, error, disabled, autoFocus }: FieldInputProps) {
  return (
    <input
      type="text"
      value={typeof value === 'string' ? value : ''}
      onChange={(e) => onChange(e.target.value)}
      disabled={disabled}
      autoFocus={autoFocus}
      placeholder={field.description ?? undefined}
      aria-invalid={!!error}
      data-testid={`field-${field.slug}-input`}
      className="w-full rounded-md border border-border-primary bg-bg-primary px-3 py-2 text-sm text-text-primary placeholder-text-muted focus:border-accent-500 focus:outline-none focus:ring-1 focus:ring-accent-500 disabled:opacity-50"
    />
  );
}

export const TextFieldType: FieldTypeDefinition = {
  type: 'text',
  renderInput: (props) => <TextInput {...props} />,
  renderCell: (_field, value) =>
    typeof value === 'string' ? value : value == null ? '' : String(value),
  defaultValue: '',
};
